var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM27(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5440_45557",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5440_45557",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4ElEQVRo3uWaS1LCQBCGZ8UJcBW8AKwtN97AcmGxxhPETXQZT0FRngZOABYeQF3jjkcQi8q0/2CHCk8jhiQ9TtVfvGf+T5OZ6elWKoWmx8NTPZvdDK7Om4PLsw70Ao2hkGWev/Jn5jsNqKLybOF4eELz+T2F4RMRaTwSAAjGkkpDPegOKmdm/P36woHxR9L6g+Lt9wBxTaEW5BzNODovQT5MBsbsRvsbQKQAejBjpW2+CvUXg8DkEQEiPUO1tMzXocmy82wAiMesH2ycvs27PItQDgDEY9/SgX95l2cKyhEgmq3cQy6bcGuH2QNE/4l6UvO1lWu+GADRPVFNMlX293aUHwCxt9I+AP/HTvIFMPJ3mXd4ISk6QLB1xealnAQAGLXWzZd5PyIFYLqyAcQLL/GPiwFg5MUBegIBupH5ytYVt/gAehEUcXREAgGMGopDPKkATcVxqlSAjsLAbyS1wbsBCAQDTBSCcy0WAN4tABB/CUm/iYVPo20rFjLxWwnZmznekXbFbqdtCWhkh5Tig3orjlXEH2xZcbQYy8bIPNy14njdigRHwVJMLv3LJF/OadZ+4hu2gIluP/VEtxWlBhvFHqPUij28TIs9dpbbfC7LbdpcbjOKlduM+L3Uy22+ABvftIU7Su08AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM27);
export default __webpack_public_path__ + "static/media/m27.7a040588173d66581a1bd8da5f6a89d9.svg";
export { ForwardRef as ReactComponent };